import { createFileRoute } from "@tanstack/react-router";
import { MaskRedirect } from "@/features/shared/route-masking";

export const Route = createFileRoute("/admin/customers/create")({
  component: () => (
    <MaskRedirect
      to="/admin/customers"
      action="create-customer"
      mask="/admin/customers/create"
    />
  ),
});
